<template>
    <el-dialog
        title="上传菜品"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="handleClose"
        center
    >
        <el-form
            label-width="100px"
            :model="form"
            :rules="rules"
            ref="ruleForm"
            class="form"
            size="small"
        >
            <el-form-item label="菜品名称" prop="name">
                <el-input v-model="form.name" class="foodName"></el-input>
            </el-form-item>
            <el-form-item label="上传附件" prop="other">
                <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-success="uploadSuccess"
                    :file-list="fileList"
                    list-type="picture"
                >
                    <el-button
                        size="small"
                        style="width: 350px; border-radius: 0"
                        ><i class="el-icon-upload"></i>点击上传</el-button
                    >
                    <div slot="tip" class="el-upload__tip">注:只能上传一张图片</div>
                </el-upload>
            </el-form-item>
            <!-- <el-form-item>
                <el-button @click="onSubmit" class="submitBtn">保存</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button  @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="onSubmit">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {
    baseUrl,
    editDishes,
    addDishes
} from '@services/tokenService.js';
export default {
    data() {
        return {
            imageId: '',
            shopId: '',
            dialogVisible: false,
            uploadUrl: `${baseUrl}/api/ZhuJingBanXieHui/UploadFile`,
            fileList: [],
            form:{
                name: "",
                other: "",
            },
            rules: {
                name: [
                    { required: true, message: '请输入菜品名称', trigger: 'blur' },
                ],
                other: [
                    { required: true, message: '请上传附件', trigger: 'blur' },
                ]
            }
        };
    },
    created() {
        this.shopId = this.$route.query.id;
    },
    methods: {
        hide() {
            this.dialogVisible = false;
            this.$refs['ruleForm'].resetFields();
            this.fileList = [];
        },
        show(data) {
            console.log(data);
            if (data) {
                this.imageId = data.ImageId;
                this.form.name = data.Title;
                this.form.other = data.ImageUrl;
                let fileArr = data.ImageUrl.split('/');
                    this.fileList = [{
                        name: fileArr[fileArr.length - 1],
                        url: data.ImageUrl
                    }];
            }
            this.dialogVisible = true;
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        uploadSuccess( response, file, fileList) {
            let url = response.data.url;
            this.fileList.push({
                name: file.name,
                url: url
            })
            this.form.other = url;
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleRemove(file, fileList) {
            // 去删除的文件
            this.fileList = this.fileList.filter(item => item.uuid !== file.uuid);
            console.log(file, fileList, this.fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        onSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    if (this.imageId) {
                        this.editDishes();
                    } else {
                        this.addDishes();
                    }
                } else {
                    return false;
                }
            });
        },
        addDishes() {
            let param = {
                ServiceId: this.shopId,
                Title: this.form.name,
                ImageUrl: this.form.other,
            };
            addDishes(param).then(res => {
                if (res.Code === 1) {
                    this.$message.success("推荐菜品保存成功！");
                    this.hide();
                    this.$emit("getDishesList");
                } else {
                    this.$message.error("推荐菜品保存失败!");
                }
            })
        },
        editDishes() {
            let param = {
                ImageId: this.imageId,
                ServiceId: this.shopId,
                Title: this.form.name,
                ImageUrl: this.form.other,
            };
            editDishes(param).then(res => {
                if (res.Code === 1) {
                    this.$message.success("推荐菜品保存成功！");
                    this.hide();
                    this.$emit("getDishesList");
                } else {
                    this.$message.error("推荐菜品保存失败!");
                }
            })
        }
    },
};
</script>

<style scoped>
.foodName {
    width: 350px;
}
</style>